import React from "react";

import Tooltip from "../../../../components/ui/tooltips/Tooltip";

import { GiMineTruck } from "react-icons/gi";
import { PiToolbox } from "react-icons/pi";
import { GrUserWorker } from "react-icons/gr";
import { FaTruckLoading  } from "react-icons/fa";
import { IoLocationOutline, IoTimeOutline } from "react-icons/io5";

/**
 * Compact icon row indicating which scope extras are configured: custom time,
 * custom address, concrete, equipment, subcontractors, and dumping.
 *
 * @param {Object} props
 * @param {Object} props.scope Scope aspect object with detail arrays and custom fields.
 * @param {boolean} [props.tooltip=false] When true, show hover labels on each icon.
 * @returns {JSX.Element|null}
 */
const DetailsIcons = ({ scope, tooltip = false }) => {
  return (
    scope && (
      <div className="flex space-x-[2px]">
        {scope.custom_time ? (
          <div className="group/concreteicon flex items-center justify-center pt-[2px]">
            <IoTimeOutline className="w-[18px] h-[18px]" />
            {tooltip && (
              <div className="absolute scale-0 bg-gray-600 text-white p-[1px] px-[2px] rounded group-hover/concreteicon:scale-100">
                <Tooltip text="Concrete" icon={false} />
              </div>
            )}
          </div>
        ) : null}
        {scope.custom_address ? (
          <div className="group/concreteicon flex items-center justify-center pt-[2px]">
            <IoLocationOutline className="w-[18px] h-[18px]" />
            {tooltip && (
              <div className="absolute scale-0 bg-gray-600 text-white rounded group-hover/concreteicon:scale-100">
                <Tooltip text="Concrete" icon={false} />
              </div>
            )}
          </div>
        ) : null}
        {scope.concrete.length > 0 ? (
          <div className="group/concreteicon flex items-center justify-center pt-[2px]">
            <GiMineTruck className="w-[18px] h-[18px]" />
            {tooltip && (
              <div className="absolute scale-0 bg-gray-600 text-white p-[1px] px-[2px] rounded group-hover/concreteicon:scale-100">
                <Tooltip text="Concrete" icon={false} />
              </div>
            )}
          </div>
        ) : null}
        {scope.equipment.length > 0 ? (
          <div className="group/equipicon flex items-center justify-center pt-[2px]">
            <PiToolbox className="w-[18px] h-[18px]" />
            {tooltip && (
              <div className="absolute scale-0 bg-gray-600 text-white p-[1px] px-[2px] rounded group-hover/equipicon:scale-100">
                <Tooltip text="Equipment" icon={false} />
              </div>
            )}
          </div>
        ) : null}
        {scope.subcontractor.length > 0 ? (
          <div className="group/contractoricon flex items-center justify-center pt-[2px]">
            <GrUserWorker className="w-[18px] h-[16px]" />
            {tooltip && (
              <div className="absolute scale-0 bg-gray-600 text-white p-[1px] px-[2px] rounded group-hover/contractoricon:scale-100">
                <Tooltip text="Contractors" icon={false} />
              </div>
            )}
          </div>
        ) : null}
        {scope.dumping.length > 0 ? (
          <div className="group/dumpingicon flex items-center justify-center pt-[2px]">
            <FaTruckLoading className="w-[18px] h-[18px]" />
            {tooltip && (
              <div className="absolute scale-0 bg-gray-600 text-white p-[1px] px-[2px] rounded group-hover/dumpingicon:scale-100">
                <Tooltip text="Dumping" icon={false} />
              </div>
            )}
          </div>
        ) : null}
      </div>
    )
  );
};

export default DetailsIcons;
